import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import {displayDateFromTimestamp, displayDatetimeFromTimestamp, getDiamondImage, formatDiamondTitle, formatDiamondTitleSku, formatMeasurements, formatLocation, formatCut, formatPolish, formatSymmetry, formatFluorescence, formatCarat, formatCost, formatColor, formatPrice, formatClarity} from '../../../utils/formatting';
import {isGM} from '../../../utils/auth';

import RhinoConfirm from '../../common/confirm/RhinoConfirm';

import * as commonActionCreators from '../../../actions/common';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, messagesActionCreators, usersActionCreators);

class Messages extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      sortByOpen: false,
      sortByDisplay: 'Date',
      expandedMessages: [],
      deleteAllConfirmOpen: false,
    }

    // Fetch user messages
    this.props.fetchUserMessages()
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
    .catch((errorResp) => {
      // Do nothing; expected error if not logged in
      // console.error(errorResp);
    });      

    // Fetch user directory
    if(this.props.messages.directory === null) {
      this.props.fetchUserDirectory()
      .then((respData) => {
        this.props.messagesSaveDirectory(respData.users);
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in
        // console.error(errorResp);
      });      
    }

    // Fetch sent messages
    this.props.fetchSentUserMessages()
    .then((respData) => {
      this.props.messagesSaveSent(respData.messages);
    })
    .catch((errorResp) => {
      // Do nothing; expected error if not logged in
      // console.error(errorResp);
    });      

    // Bind event listeners
    this.checkSortBy = this.checkSortBy.bind(this);
  }

  componentWillMount() {
    document.addEventListener('click', this.checkSortBy, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkSortBy, false);
  }

  checkSortBy(evt) {

    if(this.state.sortByOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.sortByMenuBody || targetElement == this.sortByLabel || targetElement == this.sortByArrow || targetElement == this.sortByDisplay) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ sortByOpen: false });
    }
  }

  userNav(page) {
    history.push('/' + page);
  }

  diamondNav(diamond) {
    history.push('/diamond/view/' + diamond.id);
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  selectSort(displayValue) {

    let currentSort = this.state.sortByDisplay;

    if(this.state.sortByDisplay != displayValue) {
      this.setState({ sortByDisplay: displayValue });
    } else {
      // No action needed
    }
  }

  toggleSortByMenu() {
    this.setState({ sortByOpen: !this.state.sortByOpen });
  }

  expandMessage(message, shouldMarkAsRead = true) {

    let clone = this.cloneArray(this.state.expandedMessages);
    let i = this.state.expandedMessages.indexOf(message.id);

    if(i === -1) {
      clone.push(message.id);
      if(shouldMarkAsRead) {
        this.markAsRead(message);
      }
    } else {
      clone.splice(i, 1);
    }
    this.setState({ expandedMessages: clone });
  }

  markAsRead(message) {
    if(message.unread) {
      this.setState({
        unreadCount: this.state.unreadCount - 1,
      });
    }

    let messageData = {
      message_id: message.id,
    }

    this.props.recordMessageRead(messageData)
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
    // .catch((errorResp) => {
    //   console.error(errorResp);
    // });      
  }

  deleteMessage(message) {
    
    let messageData = {
      message_id: message.id,
    }

    this.props.messagesDeleteMessage(messageData)
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
  }

  getEntryClass(message) {
    let expanded = this.state.expandedMessages.indexOf(message.id) > -1 ? ' expanded' : '';
    let unread = message.unread ? '' : ' read';

    return 'messageListItem' + expanded + unread;
  }

  getMessageTitle(message) {
    if(message.diamonds.length > 0) {
      return message.sent_by.first_name + ' ' + message.sent_by.last_name + ' has shared a diamond';
    } else if(message.hold_requests !== null && message.hold_requests.length > 0) {
      return 'Hold request from ' + message.sent_by.first_name + ' ' + message.sent_by.last_name;
    } else if(message.transfer_requests !== null && message.transfer_requests.length > 0) {
      return 'Transfer request from ' + message.sent_by.first_name + ' ' + message.sent_by.last_name;
    } else {
      return message.sent_by.first_name + ' ' + message.sent_by.last_name + ' has sent you a message';
    }
  }

  approveHold(holdReq) {
    let messageData = {
      hold_id: holdReq.id,
    }
    this.props.messagesApproveHold(messageData)
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
    .catch((errorResp) => {
      // Do nothing; expected error if not logged in
      // console.error(errorResp);
    });
    this.props.commonAlert('Hold request approved');
  }

  approveTransfer(message, transferReq) {
    let messageData = {
      message_id: message.id,
      transfer_id: transferReq.id,
    }
    this.props.messagesApproveTransfer(messageData)
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
    .catch((errorResp) => {
      // Do nothing; expected error if not logged in
      // console.error(errorResp);
    });
    this.props.commonAlert('Transfer request approved');
  }

  rejectHold(holdReq) {
    let messageData = {
      hold_id: holdReq.id,
    }
    this.props.messagesRejectHold(messageData)
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
    .catch((errorResp) => {
      // Do nothing; expected error if not logged in
      // console.error(errorResp);
    });
    this.props.commonAlert('Hold request rejected');
  }

  rejectTransfer(transferReq) {
    let messageData = {
      transfer_id: transferReq.id,
    }
    this.props.messagesRejectTransfer(messageData)
    .then((respData) => {
      this.props.messagesSave(respData.messages);
    })
    .catch((errorResp) => {
      // Do nothing; expected error if not logged in
      // console.error(errorResp);
    });
    this.props.commonAlert('Transfer request rejected');
  }

  transferResponded(transferReq) {
    return !(transferReq.approve_date === null && transferReq.reject_date === null);
  }

  transferApproveClass(transferReq) {
    return this.transferResponded(transferReq) && transferReq.approve_date !== null ? 'approveButton actionButton' : 'approveButton secondaryButton';
  }

  transferRejectClass(transferReq) {
    return this.transferResponded(transferReq) && transferReq.reject_date !== null ? 'approveButton actionButton' : 'approveButton secondaryButton';
  }

  holdResponded(holdReq) {
    return !(holdReq.approve_date === null && holdReq.reject_date === null);
  }

  holdApproveClass(holdReq) {
    return this.holdResponded(holdReq) && holdReq.approve_date !== null ? 'approveButton actionButton' : 'approveButton secondaryButton';
  }

  holdRejectClass(holdReq) {
    return this.holdResponded(holdReq) && holdReq.reject_date !== null ? 'approveButton actionButton' : 'approveButton secondaryButton';
  }

  getMessageList() {
    if(this.state.sortByDisplay === 'Sent') {
      return this.props.messages.sentMessages === null ? [] : this.props.messages.sentMessages;
    } else if(this.state.sortByDisplay === 'Deleted') {
      return this.props.messages.deletedMessages === null ? [] : this.props.messages.deletedMessages;
    }
    return this.props.messages.userMessages;
  }

  hasMessages() {
    let msgs = this.getMessageList();
    return msgs === null || msgs.length === 0;    
  }

  isTransferReq(message) {
    return message.transfer_requests !== null && message.transfer_requests.length >= 1;
  }

  isHoldReq(message) {
    return message.hold_requests !== null && message.hold_requests.length >= 1;
  }

  backButton() {
    window.history.back();
  }

  openDeleteAllConfirm() {
    this.setState({
      deleteAllConfirmOpen: true,
    });
  }

  deleteAllConfirm() {
    this.props.deleteAllMessagesAction()
    .then((respData) => {
      this.props.messagesSave(respData.messages);
      this.setState({
        deleteAllConfirmOpen: false,
      }, () => {
        this.props.commonAlert('Messages deleted');
      });
    })
  }

  deleteAllCancel() {
    this.setState({
      deleteAllConfirmOpen: false,
    });
  }

  render() {

    return <div className='Messages'>
      <div className='messageControl'>
        <div className={isGM() ? 'sortControlWrapper tallGM' : 'sortControlWrapper'}>
          
          <div className='sortByLabel' onClick={this.toggleSortByMenu.bind(this)} ref={(sortByLabel) => { this.sortByLabel = sortByLabel; }}>
            Sort By
            <div className={this.state.sortByOpen ? 'sortByMenu resultsMenu open' :  'sortByMenu resultsMenu'} ref={(sortByMenuBody) => { this.sortByMenuBody = sortByMenuBody; }}>
              <div className='menuInnerWrapper'>
                <div 
                  className={this.state.sortByDisplay == 'Date' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('Date')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>Date
                </div>
                <div 
                  className={this.state.sortByDisplay == 'Unread' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('Unread')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>Unread
                </div>
                <div 
                  className={this.state.sortByDisplay == 'Read' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('Read')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>Read
                </div>
                <div 
                  className={this.state.sortByDisplay == 'Sent' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('Sent')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>Sent
                </div>
                <div 
                  className={this.state.sortByDisplay == 'Deleted' ?  'menuEntry selected' : 'menuEntry'} 
                  onClick={() => this.selectSort('Deleted')}>
                  <div className='selectCheck'><i className="fas fa-check"></i></div>Deleted
                </div>
              </div>
            </div>
          </div>
          {this.state.sortByDisplay ?
            <div className='sortByDisplay' onClick={this.toggleSortByMenu.bind(this)} ref={(sortByDisplay) => { this.sortByDisplay = sortByDisplay; }}>{this.state.sortByDisplay}</div> :
            null
          }
          <div className='sortByArrow' onClick={this.toggleSortByMenu.bind(this)} ref={(sortByArrow) => { this.sortByArrow = sortByArrow; }}>
            <img src='/img/results/arrow.svg' />
          </div>
        </div>
        <div className={'actionButton sendMessageButton'} onClick={() => this.props.messagesOpenNewDropdown()}>Send New Message</div>
        <div className={'actionButton sendMessageButton superSmallButton'} onClick={() => this.props.messagesOpenNewDropdown()}>New</div>
        {isGM() ?
          <div className={'actionButton deleteAllMessagesButton'} onClick={() => this.openDeleteAllConfirm()}>Delete All</div> :
          null
        }
      </div>
      <div className='messagesWrapper'>
        {this.hasMessages() ?
          <div className='nullMessages'>No messages</div> :
          <div>
            {this.state.sortByDisplay === 'Sent' ?
              <div className={'messageListWrapper messageSentListWrapper'}>
                {this.getMessageList().map((message, i) => {

                  if(message.hold_requests.length > 0 || message.transfer_requests.length > 0) {
                    return null;
                  }

                  return <div className={this.getEntryClass(message)} key={i}>
                    <div className='messageDefaultWrapper' onClick={() => this.expandMessage(message, false)}>
                      <div className={'messageTitle EllipsisElement'}>{this.getMessageTitle(message)}</div>
                      <div className='messageDate'>{displayDatetimeFromTimestamp(message.send_date)}</div>
                      <div className={this.state.expandedMessages.indexOf(message.id) > -1 ? 'messageArrow open' : 'messageArrow'}>
                        <img src='/img/results/arrow.svg' />
                      </div>
                      {message.transfer_request ?
                        <div className='messageLocation'>{message.transfer_request.request_location.short_name}</div> :
                        null
                      }
                    </div>
                    <div className='messageExpandedWrapper'>
                      <div className='messageTextWrapper'>
                        {message.message_body ?
                          <div className='messageTextBody'>{message.message_body}</div> :
                          null
                        }
                        {message.diamonds && message.diamonds.length > 0 ?
                          <div>
                            {message.diamonds.map((diamond, i) => {
                              return <div className='diamondWrapper' key={i}>
                                <div className='diamondImageWrapper' onClick={() => this.diamondNav(diamond)}>
                                  <img src={getDiamondImage(diamond)} />
                                </div>
                                <div className='diamondBodyWrapper'>
                                  <div className='diamondTitle'>
                                    {formatDiamondTitle(diamond)}
                                    <button className={'viewButton secondaryButton'} onClick={() => this.diamondNav(diamond)}>View</button>
                                  </div>
                                  <div className='diamondMeasurementRow'>
                                    {diamond.measurements ? 
                                      <div className='diamondMeasurements'>{formatMeasurements(diamond)}</div> :
                                      null
                                    }
                                    <div className='diamondLocation'>
                                      <div className='diamondLocationIcon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                      </div>
                                      <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                                    </div>
                                  </div>
                                  <div className='diamondInfoBlock'>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Cut:</div>
                                      <div className='diamondInfoValue'>{formatCut(diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Symmetry:</div>
                                      <div className='diamondInfoValue'>{formatSymmetry(diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Polish:</div>
                                      <div className='diamondInfoValue'>{formatPolish(diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Fluorescence:</div>
                                      <div className='diamondInfoValue'>{formatFluorescence(diamond)}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            })}
                          </div> :
                          null
                        }
                      </div>
                    </div>
                  </div>
                })}
              </div> :
              <div className='messageListWrapper'>
                {this.getMessageList().map((message, i) => {
                  if(this.state.sortByDisplay === 'Read' && message.unread) {
                    return null;
                  }

                  if(this.state.sortByDisplay === 'Unread' && !message.unread && this.state.expandedMessages.indexOf(message.id) === -1) {
                    return null;
                  }

                  return <div className={this.getEntryClass(message)} key={i}>
                    <div className='messageDefaultWrapper' onClick={() => this.expandMessage(message)}>
                      <div className={'messageTitle EllipsisElement'}>{this.getMessageTitle(message)}</div>
                      <div className='messageDate'>{displayDatetimeFromTimestamp(message.send_date)}</div>
                      <div className={this.state.expandedMessages.indexOf(message.id) > -1 ? 'messageArrow open' : 'messageArrow'}>
                        <img src='/img/results/arrow.svg' />
                      </div>
                      {message.transfer_request ?
                        <div className='messageLocation'>{message.transfer_request.request_location.short_name}</div> :
                        null
                      }
                    </div>
                    <div className='messageExpandedWrapper'>
                      <div className='messageTextWrapper'>
                        {message.message_body ?
                          <div className='messageTextBody'>{message.message_body}</div> :
                          null
                        }
                        {message.diamonds && message.diamonds.length > 0 ?
                          <div>
                            {message.diamonds.map((diamond, i) => {
                              return <div className='diamondWrapper' key={i}>
                                <div className='diamondImageWrapper' onClick={() => this.diamondNav(diamond)}>
                                  <img src={getDiamondImage(diamond)} />
                                </div>
                                <div className='diamondBodyWrapper'>
                                  <div className='diamondTitle'>
                                    {formatDiamondTitle(diamond)}
                                    <button className={'viewButton secondaryButton'} onClick={() => this.diamondNav(diamond)}>View</button>
                                  </div>
                                  <div className='diamondMeasurementRow'>
                                    {diamond.measurements ? 
                                      <div className='diamondMeasurements'>{formatMeasurements(diamond)}</div> :
                                      null
                                    }
                                    <div className='diamondLocation'>
                                      <div className='diamondLocationIcon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                      </div>
                                      <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                                    </div>
                                  </div>
                                  <div className='diamondInfoBlock'>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Cut:</div>
                                      <div className='diamondInfoValue'>{formatCut(diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Symmetry:</div>
                                      <div className='diamondInfoValue'>{formatSymmetry(diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Polish:</div>
                                      <div className='diamondInfoValue'>{formatPolish(diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Fluorescence:</div>
                                      <div className='diamondInfoValue'>{formatFluorescence(diamond)}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            })}
                          </div> :
                          null
                        }
                        {message.hold_requests && message.hold_requests.length > 0 ?
                          <div>
                            {message.hold_requests.map((holdReq, j) => {
                              return <div className={'diamondWrapper holdDiamond'} key={j}>
                                <div className='diamondImageWrapper' onClick={() => this.diamondNav(holdReq.diamond)}>
                                  <img src={getDiamondImage(holdReq.diamond)} />
                                  <button className={'viewHoldButton secondaryButton'} onClick={() => this.diamondNav(holdReq.diamond)}>View</button>
                                </div>
                                <div className='diamondBodyWrapper'>
                                  <div className={'diamondTitle EllipsisElement'} onClick={() => this.diamondNav(holdReq.diamond)}>
                                    {formatDiamondTitleSku(holdReq.diamond)}
                                  </div>
                                  <div className='diamondMeasurementRow'>
                                    {holdReq.diamond.measurements ? 
                                      <div className='diamondMeasurements'>{formatMeasurements(holdReq.diamond)}</div> :
                                      null
                                    }
                                    <div className='diamondLocation'>
                                      <div className='diamondLocationIcon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                      </div>
                                      <div className='diamondLocationName'>{formatLocation(holdReq.diamond)}</div>
                                    </div>
                                  </div>
                                  <div className='diamondsControlWrapper'>
                                    <button className={this.holdApproveClass(holdReq)} disabled={this.holdResponded(holdReq)} onClick={() => this.approveHold(holdReq)}>Approve</button>
                                    <button className={this.holdRejectClass(holdReq)} disabled={this.holdResponded(holdReq)} onClick={() => this.rejectHold(holdReq)}>Reject</button>
                                  </div>
                                  <div className='diamondInfoBlock'>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Cut:</div>
                                      <div className='diamondInfoValue'>{formatCut(holdReq.diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Symmetry:</div>
                                      <div className='diamondInfoValue'>{formatSymmetry(holdReq.diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Polish:</div>
                                      <div className='diamondInfoValue'>{formatPolish(holdReq.diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Fluorescence:</div>
                                      <div className='diamondInfoValue'>{formatFluorescence(holdReq.diamond)}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            })}
                          </div> :
                          null
                        }
                        {message.transfer_requests && message.transfer_requests.length > 0 ?
                          <div>
                            {message.transfer_requests.map((transferReq, j) => {
                              return <div className={'diamondWrapper transferDiamond'} key={j}>
                                <div className='diamondImageWrapper' onClick={() => this.diamondNav(transferReq.diamond)}>
                                  <img src={getDiamondImage(transferReq.diamond)} />
                                  <button className={'viewHoldButton secondaryButton'} onClick={() => this.diamondNav(transferReq.diamond)}>View</button>
                                </div>
                              
                                <div className='diamondBodyWrapper'>
                                  <div className={'diamondTitle EllipsisElement'} onClick={() => this.diamondNav(transferReq.diamond)}>
                                    {formatDiamondTitleSku(transferReq.diamond)}
                                  </div>
                                  <div className='diamondMeasurementRow'>
                                    {transferReq.diamond.measurements ? 
                                      <div className='diamondMeasurements'>{formatMeasurements(transferReq.diamond)}</div> :
                                      null
                                    }
                                    <div className='diamondLocation'>
                                      <div className='diamondLocationIcon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                      </div>
                                      <div className='diamondLocationName'>{formatLocation(transferReq.diamond)}</div>
                                    </div>
                                  </div>
                                  <div className='diamondsControlWrapper'>
                                    <button className={this.transferApproveClass(transferReq)} disabled={this.transferResponded(transferReq)} onClick={() => this.approveTransfer(message, transferReq)}>Approve</button>
                                    <button className={this.transferRejectClass(transferReq)} disabled={this.transferResponded(transferReq)} onClick={() => this.rejectTransfer(transferReq)}>Reject</button>
                                  </div>
                                  <div className='diamondInfoBlock'>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Cut:</div>
                                      <div className='diamondInfoValue'>{formatCut(transferReq.diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Symmetry:</div>
                                      <div className='diamondInfoValue'>{formatSymmetry(transferReq.diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Polish:</div>
                                      <div className='diamondInfoValue'>{formatPolish(transferReq.diamond)}</div>
                                    </div>
                                    <div className='diamondInfoItem'>
                                      <div className='diamondInfoLabel'>Fluorescence:</div>
                                      <div className='diamondInfoValue'>{formatFluorescence(transferReq.diamond)}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            })}
                          </div> :
                          null
                        }
                        <div className='messageTextButtonWrapper' style={{display: this.state.sortByDisplay === 'Deleted' ? 'none' : 'block'}}>
                          <button className={'messageTextReplyButton secondaryButton'} onClick={() => this.props.messagesOpenNewDropdown(message.sent_by)}>Reply</button>
                          <button className={'messageTextDeleteButton secondaryButton'} onClick={() => this.deleteMessage(message)}>Delete</button>
                        </div>
                      </div>
                    </div>
                  </div>
                })}
              </div>
            }
          </div>
        }
      </div>
      <div className={'messagesBack bottomAction alwaysBottom'} onClick={this.backButton.bind(this)}>Back</div>
      <div className='bottomActionSpacer alwaysBottom'></div>
      <RhinoConfirm
        confirmText='Are you sure you want to delete all messages?'
        confirmMethod={this.deleteAllConfirm.bind(this)}
        cancelMethod={this.deleteAllCancel.bind(this)}
        open={this.state.deleteAllConfirmOpen} />
    </div>;
  }
}
export default Messages;


function mapStateToProps(state) {
  return {
    messages: state.messages,
  };
}

export const MessagesContainer = connect(
  mapStateToProps,
  allActionCreators
)(Messages);